/**
 * Zone.js configuration flags to prevent conflicts with Socket.IO
 * This file must be imported before zone.js in polyfills.ts
 */

// Only disable WebSocket patching to prevent conflicts with Socket.IO
// Keep other Zone.js functionality intact for Angular to work properly
(window as any).__Zone_disable_WebSocket = true;
